<template>
<div class="chapter">
<div class="inner_page">
<h2 class="contentsHead" style="text-indent: 0%"><i>CONTENTS</i></h2>
<br/>
<p class="contentsEntryName" style="text-indent: 0%"><a href="#/text/Thor#thor">Brad Thor</a></p>
<br/><br/>
<p class="contentsEntryName" style="text-indent: 0%"><span href="#/text/Athens#athens" title="Link target outside of Sample">The Athens Solution</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?4b57c45a